import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notifyUser } from "components/shared-components/AdvancareNotification";
import ResultService from "services/ResultService";
import { formatValidationErrors } from "utils/ArrayUtils";

export const initialState = {
  list: [],
  loading: false,
  uploading: false,
  updating: false,
  errorMessages: [],
  showMessage: false,
};

export const fetchResults = createAsyncThunk(
  "/fetchResults",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ResultService.fetch(data);
      var code = response.code;
      return {
        code: code,
        results: response.data,
      };
    } catch (err) {
      let code = err.response?.data.code;
      let response = err.response;
      return rejectWithValue({
        code: code,
        errorMessages: response?.data?.message || "Error",
      });
    }
  }
);

export const uploadResults = createAsyncThunk(
  "/uploadResults",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await ResultService.upload(formData);
      const code = response.code;
      return {
        code: code,
        messages: response.message,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Error uploading the result",
        }
      );
    }
  }
);

export const updateResults = createAsyncThunk(
  "/updateResults",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await ResultService.update(formData);
      const code = response.code;
      return {
        code: code,
      };
    } catch (err) {
      return rejectWithValue({ error: "Error updating the result" });
    }
  }
);

export const resultSlice = createSlice({
  name: "results",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = !state.loading;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchResults.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchResults.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.results;
      })
      .addCase(fetchResults.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(uploadResults.pending, (state, action) => {
        state.uploading = true;
      })
      .addCase(uploadResults.fulfilled, (state, action) => {
        state.uploading = false;
        window.location.reload();
      })
      .addCase(uploadResults.rejected, (state, action) => {
        state.errorMessages = action.payload;
        if (action.payload.code == 422) {
          state.errorMessages = formatValidationErrors(action.payload.error);
        } else {
          state.errorMessages = action.payload.error;
        }
        state.uploading = false;
      })
      .addCase(updateResults.pending, (state, action) => {
        state.updating = true;
      })
      .addCase(updateResults.fulfilled, (state, action) => {
        state.updating = false;
        window.location.reload();
      })
      .addCase(updateResults.rejected, (state, action) => {
        // notifyUser("error", "TopRight", "Error updating the result");
        state.updating = false;
      });
  },
});

export const { showLoading } = resultSlice.actions;

export default resultSlice.reducer;
